/* eslint-disable no-param-reassign */
import { CaseReducer, SliceCaseReducers } from '@reduxjs/toolkit';
import { createSlice } from 'helpers/createSlice';
import { ActionWithPayload } from 'types';

type State = Record<string, unknown>;

interface Reducers extends SliceCaseReducers<State> {
  update: CaseReducer<State, ActionWithPayload<{ name: string; props: unknown }>>;
  resetOne: CaseReducer<State, ActionWithPayload<{ name: string }>>;
  reset: CaseReducer<State>;
}

const initialState: State = {};

export const fetchRegister = createSlice<State, Reducers>({
  name: 'fetchRegister',
  initialState,
  reducers: {
    update: (state, { payload: { name, props } }) => {
      state[name] = props;
    },
    resetOne: (state, { payload: { name } }) => {
      state[name] = undefined;
    },
    reset: () => initialState,
  },
});
